import { defineRecipe } from '@chakra-ui/react/styled-system';

const colorButtonRecipe = defineRecipe({
  className: 'color-button',
  base: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid',
    borderRadius: '4',
    cursor: 'pointer',
    _disabled: {
      opacity: 0.4,
      pointerEvents: 'none',
    },
    // Loading keeps the control focusable and undimmed — only pointer activation is blocked.
    _loading: {
      pointerEvents: 'none',
    },
  },
  variants: {
    size: {
      sm: { height: '32', paddingInline: '12', textStyle: 'comp/button/sm' },
      md: { height: '40', paddingInline: '12', textStyle: 'comp/button/md' },
      lg: { height: '48', paddingInline: '16', textStyle: 'comp/button/lg' },
    },
    colorVariant: {
      neutral: {
        color: 'color/neutral/strong',
        '&:hover': { backgroundColor: 'color/neutral/subtle' },
        '&:active': { backgroundColor: 'color/neutral/moderate' },
      },
      blue: {
        color: 'color/blue/strong',
        '&:hover': { backgroundColor: 'color/blue/subtle' },
        '&:active': { backgroundColor: 'color/blue/moderate' },
      },
      green: {
        color: 'color/green/strong',
        '&:hover': { backgroundColor: 'color/green/subtle' },
        '&:active': { backgroundColor: 'color/green/moderate' },
      },
      red: {
        color: 'color/red/strong',
        '&:hover': { backgroundColor: 'color/red/subtle' },
        '&:active': { backgroundColor: 'color/red/moderate' },
      },
      yellow: {
        color: 'color/yellow/strong',
        '&:hover': { backgroundColor: 'color/yellow/subtle' },
        '&:active': { backgroundColor: 'color/yellow/moderate' },
      },
      purple: {
        color: 'color/purple/strong',
        '&:hover': { backgroundColor: 'color/purple/subtle' },
        '&:active': { backgroundColor: 'color/purple/moderate' },
      },
      orange: {
        color: 'color/orange/strong',
        '&:hover': { backgroundColor: 'color/orange/subtle' },
        '&:active': { backgroundColor: 'color/orange/moderate' },
      },
      turquoise: {
        color: 'color/turquoise/strong',
        '&:hover': { backgroundColor: 'color/turquoise/subtle' },
        '&:active': { backgroundColor: 'color/turquoise/moderate' },
      },
      indigo: {
        color: 'color/indigo/strong',
        '&:hover': { backgroundColor: 'color/indigo/subtle' },
        '&:active': { backgroundColor: 'color/indigo/moderate' },
      },
      white: {
        color: 'text/on-color',
        borderColor: 'border/inverse',
        '&:hover': { backgroundColor: 'color/white/15' },
        '&:active': { backgroundColor: 'color/white/30' },
      },
    },
  },
  defaultVariants: {
    colorVariant: 'neutral',
    size: 'sm',
  },
});

export default colorButtonRecipe;
